import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _calculateMultiSlotAvailabilityRequest = {};
var _calculateMultiSlotAvailabilityResponse = {};
var _getAvailabilityTimeSlotRequest = {};
var _getAvailabilityTimeSlotResponse = {};
var _getScheduleAvailabilityRequest = {};
var _getScheduleAvailabilityResponse = {};
var _getSlotAvailabilityRequest = {};
var _getSlotAvailabilityResponse = {};
var _queryAvailabilityRequest = {};
var _queryAvailabilityResponse = {};
function resolveComWixpressBookingsAvailabilityAvailabilityCalendarUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/availability-calendar',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/availability-calendar/v1/availability/query',
                destPath: '/v1/availability/query',
            },
            {
                srcPath: '/_api/availability-calendar/v2/availability/schedule',
                destPath: '/v2/availability/schedule',
            },
            {
                srcPath: '/_api/availability-calendar/v1/availability/multislot',
                destPath: '/v1/availability/multislot',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/availability-calendar/v1/availability/query',
                destPath: '/v1/availability/query',
            },
            {
                srcPath: '/_api/availability-calendar/v1/availability/multislot',
                destPath: '/v1/availability/multislot',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/availability-calendar/v1/availability/query',
                destPath: '/v1/availability/query',
            },
            {
                srcPath: '/_api/availability-calendar/v1/availability/multislot',
                destPath: '/v1/availability/multislot',
            },
            {
                srcPath: '/v1/availability/multislot',
                destPath: '/v1/availability/multislot',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/availability-calendar/v1/availability/query',
                destPath: '/v1/availability/query',
            },
            {
                srcPath: '/_api/availability-calendar/v1/availability/multislot',
                destPath: '/v1/availability/multislot',
            },
            {
                srcPath: '/v1/availability/multislot',
                destPath: '/v1/availability/multislot',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/availability-calendar/v1/availability/query',
                destPath: '/v1/availability/query',
            },
            {
                srcPath: '/_api/availability-calendar/v1/availability/multislot',
                destPath: '/v1/availability/multislot',
            },
            {
                srcPath: '/v1/availability/multislot',
                destPath: '/v1/availability/multislot',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/availability-calendar/v1/availability/query',
                destPath: '/v1/availability/query',
            },
        ],
        'editor-flow.wixapps.net': [
            {
                srcPath: '/_api/availability-calendar/v1/availability/query',
                destPath: '/v1/availability/query',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/availability-calendar/v1/availability/query',
                destPath: '/v1/availability/query',
            },
            {
                srcPath: '/bookings/availability-calendar/v1/availability/query',
                destPath: '/v1/availability/query',
            },
            {
                srcPath: '/bookings/v1/availability/query',
                destPath: '/v1/availability/query',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/availability-calendar/v1/availability/query',
                destPath: '/v1/availability/query',
            },
            {
                srcPath: '/_api/availability-calendar',
                destPath: '',
            },
            {
                srcPath: '/_api/availability-calendar/v2/availability/schedule',
                destPath: '/v2/availability/schedule',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/availability-calendar/v1/availability/query',
                destPath: '/v1/availability/query',
            },
            {
                srcPath: '/_api/availability-calendar/v1/availability/multislot',
                destPath: '/v1/availability/multislot',
            },
        ],
        'bookings.wixapps.net': [
            {
                srcPath: '/_api/availability-calendar/v1/availability/query',
                destPath: '/v1/availability/query',
            },
        ],
        'bo._base_domain_': [
            {
                srcPath: '/_api/availability-calendar/v1/availability/query',
                destPath: '/v1/availability/query',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/_api/availability-calendar/v1/availability/query',
                destPath: '/v1/availability/query',
            },
        ],
        'wix-bo.com': [
            {
                srcPath: '/_api/availability-calendar/v1/availability/query',
                destPath: '/v1/availability/query',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/**
 * Retrieves appointment slots or class events that match specified filters.
 *
 * ## Course limitations
 *
 * Course events can't be retrieved with this method. Follow this
 * _sample flow_
 * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/bookings/sample-flows#backend-modules_bookings_bookings_book-a-course) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/sample-booking-flows#book-a-course))
 * to check course availability.
 *
 * ## Query filter
 *
 * You must include `serviceId` in your query filter. For performance, also specify
 * both `startDate` and `endDate`. Refer to the
 * _supported filters article_
 * ([SDK](https://dev.wix.com/docs/sdk/backend-modules/bookings/availability-calendar/supported-filters-and-sorting) | [REST](https://dev.wix.com/docs/rest/business-solutions/bookings/time-slots/availability-calendar/supported-fields-filters-and-sorting))
 * for a complete list of supported filters.
 *
 * ## Limit the number of slots returned per day
 *
 * To limit the maximum number of appointment slots returned for each date,
 * specify `slotsPerDay`. For example,  specifying `{"slotsPerDay": 3}` returns
 * a maximum of 3 appointment slots/class events for each day that's within the
 * query filter's date range.
 *
 * ## Unavailable slots
 *
 * By default, both available and unavailable appointment slots/ class events
 * are returned. To retrieve only available slots/events, specify
 * `{"bookable": true}` in the filter.
 *
 * ## Sorting
 *
 * Slots/events can be sorted only by `startDate`. Unavailable slots/events
 * always appear after available ones.
 *
 * ## Availability calculation
 *
 * Wix Bookings calculates availability differently for appointment-based
 * services and classes.
 *
 * ### Appointment availability
 *
 * An appointment slot is `bookable` if:
 * - The slot's `startDate` is later than or equal to `query.filter.startDate`.
 * - The slot's `endDate` is before or equal to `query.filter.endDate`.
 * - The service's `onlineBooking.enabled` is `true`.
 * - The service's early/late booking policies are either not enabled or the
 * current time is within the defined limits.
 *
 * ### Class event availability
 *
 * A class event is `bookable` if:
 * - The event's `startDate` is later than or equal to `query.filter.startDate`.
 * - The event's `endDate` is before or equal to `query.filter.endDate`.
 * - The event's `remainingCapacity` is greater than `0`.
 * - The service's `onlineBooking.enabled` is `true`.
 * - The service's early/late booking policies are either not enabled or the
 * current time is within the defined limits.
 *
 * If you want to restrict returned class events to those with a minimum number
 * of remaining spots, specify `openSpots` in the filter. By default, all class
 * events, even those with no open spot, are returned.
 *
 * ## Daylight Savings Time (DST)
 *
 * Due to DST, some local times may not exist or may occur twice. For example,
 * in Santiago, Chile, on September 7, 2025, 0:05 AM doesn't exist because the
 * clock advances from 0:00 AM to 1:00 AM.
 *
 * Query Availability* automatically adjusts for these gaps. Non-existent times
 * are moved forward by 1 hour, while existing times remain unchanged. For
 * instance, if you call *Query Availability* with a `startDate` of
 * `2025-09-07T00:00:01.000` and an `endDate` of `2025-09-08T00:00:02.000`, the
 * adjusted query will use `2025-09-07T01:00:01.000` as the new start time.
 */
export function queryAvailability(payload) {
    var _a = serializer(_queryAvailabilityRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryAvailabilityResponse, {}).fromJSON;
    function __queryAvailability(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.availability.v1.slot_availability',
            method: 'POST',
            methodFqn: 'com.wixpress.bookings.availability.AvailabilityCalendar.QueryAvailability',
            url: resolveComWixpressBookingsAvailabilityAvailabilityCalendarUrl({
                protoPath: '/v1/availability/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryAvailability.fromReq = fromReq;
    __queryAvailability.__isAmbassador = true;
    return __queryAvailability;
}
/**
 * Returns the availability for a given slot.
 *
 * A slot for an appointment does not have a `sessionId. Only a slot for a class has a `sessionId`.
 *
 * Availability for an appointment is calculated as follows:
 * - Checking for available slots in the calendar, and calculating the open spots
 * - Checking for existing bookings with overlapping time, service & resource, where the booked session has transparency set to  `"BUSY"`  When the booking is in the process of being checked out, it may not have a sessionId yet. In this case it is considered as `"BUSY"`.
 * - Checking for booking policy violations in the services-catalog.
 * The following fields are required to get the availability for an appointment:
 * - `startDate`
 * - `endDate`
 * - `serviceId`
 * - `resourceId`
 * - `scheduleId`
 * Availability for classes is calculated as follows:
 * - Checking for total spots by the session's capacity
 * - Checking for open spots by subtracting the current number of participants from the total spots
 * - Checking for booking policy violations in the services-catalog
 * - Checking for a waitlist and its occupancy in the waiting-list
 * - Checking for locked in the locks
 * For a class, the following fields are required:
 * - `sessionId`
 */
export function getSlotAvailability(payload) {
    var _a = serializer(_getSlotAvailabilityRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getSlotAvailabilityResponse, {}).fromJSON;
    function __getSlotAvailability(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.availability.v1.slot_availability',
            method: 'POST',
            methodFqn: 'com.wixpress.bookings.availability.AvailabilityCalendar.GetSlotAvailability',
            url: resolveComWixpressBookingsAvailabilityAvailabilityCalendarUrl({
                protoPath: '/v2/availability/slot',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getSlotAvailability.fromReq = fromReq;
    __getSlotAvailability.__isAmbassador = true;
    return __getSlotAvailability;
}
/**
 * Returns availability for a given schedule ID
 * The availability for a course is calculated by:
 * - Checking for total spots by the schedule's capacity
 * - Checking for open spots by subtracting the current number of participants from the total spots
 * current number of participants is calculated by summing the number of participants of all bookings booked to the schedule
 * @deprecated
 */
export function getScheduleAvailability(payload) {
    var _a = serializer(_getScheduleAvailabilityRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getScheduleAvailabilityResponse, {}).fromJSON;
    function __getScheduleAvailability(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.availability.v1.slot_availability',
            method: 'GET',
            methodFqn: 'com.wixpress.bookings.availability.AvailabilityCalendar.GetScheduleAvailability',
            url: resolveComWixpressBookingsAvailabilityAvailabilityCalendarUrl({
                protoPath: '/v2/availability/schedule/{scheduleId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getScheduleAvailability.fromReq = fromReq;
    __getScheduleAvailability.__isAmbassador = true;
    return __getScheduleAvailability;
}
export function calculateMultiSlotAvailability(payload) {
    var _a = serializer(_calculateMultiSlotAvailabilityRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_calculateMultiSlotAvailabilityResponse, {}).fromJSON;
    function __calculateMultiSlotAvailability(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.availability.v1.slot_availability',
            method: 'POST',
            methodFqn: 'com.wixpress.bookings.availability.AvailabilityCalendar.CalculateMultiSlotAvailability',
            url: resolveComWixpressBookingsAvailabilityAvailabilityCalendarUrl({
                protoPath: '/v1/availability/multislot',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __calculateMultiSlotAvailability.fromReq = fromReq;
    __calculateMultiSlotAvailability.__isAmbassador = true;
    return __calculateMultiSlotAvailability;
}
/**
 * a decision based proxy between GetSlotAvailability and  service-availability's GetAvailabilityTimeSlot
 * this is a temporary solution based on FromV2 flag, and will be removed once all the clients are migrated to v2
 * the request will be proxied to GetSlotAvailability if from_v2 is false, and to GetAvailabilityTimeSlot if from_v2 is true
 * it supports only appointment services (NOT classes, and NOT courses)
 * in case from_v2 is not provided, the request will be proxied based on `ShouldCallAvailabilityService` FT and ResourceManagement check [exists not staff resource]
 * in case from_v2 is false and ResourceManagement check is true, an FAILED_PRECONDITION error will be thrown
 */
export function getAvailabilityTimeSlot(payload) {
    var _a = serializer(_getAvailabilityTimeSlotRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getAvailabilityTimeSlotResponse, {}).fromJSON;
    function __getAvailabilityTimeSlot(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.availability.v1.slot_availability',
            method: 'POST',
            methodFqn: 'com.wixpress.bookings.availability.AvailabilityCalendar.GetAvailabilityTimeSlot',
            url: resolveComWixpressBookingsAvailabilityAvailabilityCalendarUrl({
                protoPath: '/v1/time-slots/get',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getAvailabilityTimeSlot.fromReq = fromReq;
    __getAvailabilityTimeSlot.__isAmbassador = true;
    return __getAvailabilityTimeSlot;
}
//# sourceMappingURL=http.impl.js.map